import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";

interface UpdateObj {
  flashingFin?: string;
  flashingFinConfig?: string;
  finSetback?: string;
}

function useFinSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);

  const finChoice = useStore((state) => state.quote.flashingFin);
  const finConfigChoice = useStore((state) => state.quote.flashingFinConfig);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const finSetback = useStore((state) => state.quote.finSetback);

  const screenType = useStore((state) => state.quote.screenType);
  const addScreen = useStore((state) => state.quote.addScreen);

  const isCentor = addScreen && screenType?.includes("Centor") ? true : false;

  const material = useStore((state) => state.quote.material);

  const isAluminum = material === "All Aluminum";

  const isBifoldAlum = isAluminum && (doorType === "Bi-fold" || doorType === "Bi-fold Window");

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (!value) {
      addToQuote({ finSetback: "" });
    } else {
      addToQuote({ finSetback: value });
      if (findRequired("Flashing Fin Custom Setback"))
        removeRequired("Flashing Fin Custom Setback");
    }
  };

  const showSetbackInput =
    finChoice && finConfigChoice === "Custom Setback" ? true : false;

  const handleClickFin = (label: string) => {
    const checked = label === finChoice;

    if (checked) {
      addToQuote({
        flashingFinConfig: "",
        flashingFin: "",
      });
    } else {
      if (findRequired("Flashing Fin Custom Setback")) {
        removeRequired("Flashing Fin Setback");
        removeRequired("Flashing Fin Custom Setback");
      }

      let update: UpdateObj = {
        flashingFin: label,
        flashingFinConfig: 'Standard 1" Setback',
      };

      if (finSetback) update["finSetback"] = "";
      addToQuote(update);
    }
  };

  const handleClickOptions = (label: string) => {
    const checked = label === finConfigChoice;

    let update: UpdateObj = { finSetback: "" };

    if (checked) {
      update["flashingFinConfig"] = "";
    } else {
      if (findRequired("Flashing Fin Custom Setback")) {
        removeRequired("Flashing Fin Setback");
      }
      update["flashingFinConfig"] = label;
    }

    addToQuote(update);
  };

  return {
    handleClickFin,
    handleClickOptions,
    showSetbackInput,
    handleChange,
    isCentor,
    finChoice,
    finConfigChoice,
    finSetback,
    isAluminum,
    isBifoldAlum
  };
}

export default useFinSelector;
